// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".payment-wrapper[data-v-e38ceed4]{text-align:center;padding:45px 0 77px}.result-img[data-v-e38ceed4]{display:inline-block}.to-orders[data-v-e38ceed4]{margin-top:7px;color:#a8aaaf}.result-heading[data-v-e38ceed4]{display:block;margin:30px 0 0;font-size:20px;line-height:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
